import ReactGA from 'react-ga4';

// Check if user has consented to cookies
export const hasConsent = () => {
  return localStorage.getItem('cookieConsent') === 'accepted';
};

// Initialize Google Analytics if consent is given
export const initializeGA = () => {
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    if (hasConsent() && !window.gtag) {
      ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
      return true;
    }
  }
  return false;
};

// Send pageview only if consent is given
export const sendPageview = (page, title) => {
  if (hasConsent() && process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.send({ 
      hitType: 'pageview', 
      page: page || window.location.pathname + window.location.search, 
      title: title || document.title 
    });
  }
};

// Send event only if consent is given
export const sendEvent = (eventData) => {
  if (hasConsent() && process.env.NODE_ENV === 'production' && process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event(eventData);
  }
};

// Export ReactGA for direct access if needed (with consent check wrapper)
export { ReactGA };

